var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMute = function SvgMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.2 11",
    style: {
      enableBackground: "new 0 0 16.2 11"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.4,0.1C7-0.1,6.5,0,6.1,0.3L2.9,3H1.2C0.6,3,0,3.6,0,4.2v2.5c0,0.3,0.1,0.6,0.4,0.9C0.6,7.8,0.9,8,1.2,8 c0,0,0,0,0,0h1.6l3.3,2.7C6.4,10.9,6.6,11,6.9,11c0.2,0,0.4,0,0.5-0.1c0.4-0.2,0.7-0.6,0.7-1.1V1.2C8.1,0.8,7.9,0.3,7.4,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.9,5.6L16,3.5c0.2-0.2,0.2-0.6,0-0.8s-0.6-0.2-0.8,0l-2.1,2.1L11,2.7c-0.2-0.2-0.6-0.2-0.8,0 s-0.2,0.6,0,0.8l2.1,2.1l-2.1,2.1c-0.2,0.2-0.2,0.6,0,0.8c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2l2.1-2.1l2.1,2.1 c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.8L13.9,5.6z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mute.623952cd.svg";
export { ForwardRef as ReactComponent };